import React, { useState, useEffect } from "react";
import { websiteUrl } from "../../const/constants";
import HomeBG from "../../Assets/images/HomeBg.png";

const AajKiBaat = ({ ayats, heroImage }) => {
  const [currentAyat, setCurrentAyat] = useState(null);
  const bgImageUrl = heroImage
    ? `${websiteUrl}/mainImage/${heroImage}`
    : HomeBG;

  // Set initial ayat and shuffle every 10 seconds
  useEffect(() => {
    // Function to select a random ayat
    const getRandomAyat = () => {
      if (!ayats || ayats.length === 0) return null;
      const randomIndex = Math.floor(Math.random() * ayats.length);
      return ayats[randomIndex];
    };
    // Set initial ayat
    setCurrentAyat(getRandomAyat());

    // Set up interval to shuffle every 10 seconds
    const interval = setInterval(() => {
      setCurrentAyat(getRandomAyat());
    }, 10000); // 10 seconds

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [ayats]); // Re-run if ayats prop changes

  if (!ayats || ayats.length === 0 || !currentAyat) {
    return (
      <div
        className="lg:mt-20 md:mt-18 mt-8 h-[500px] bg-cover bg-center bg-no-repeat rounded-3xl flex flex-col items-center justify-center px-10 lg:px-80"
        style={{ backgroundImage: `url(${bgImageUrl})` }}
      >
        <h1 className="font-nastaleeqKasheeda text-2xl lg:text-4xl">
          آج کی بات
        </h1>
      </div>
    );
  }

  return (
    <div
      className="lg:mt-20 md:mt-18 mt-8 h-[350px] md:h-[400px] lg:h-[500px] bg-cover  bg-center bg-no-repeat rounded-3xl flex flex-col items-center justify-center"
      style={{ backgroundImage: `url(${bgImageUrl})` }}
    >
      <div
        key={currentAyat.id} // Use id to trigger re-render for transition
        className="fade-container text-center px-4"
        style={{
          animation: "fadeIn 1s ease-in-out",
        }}
      >
        <h1 className="font-nastaleeqKasheeda text-xl md:text-2xl lg:text-2xl">
          {currentAyat.title}
        </h1>

        <p className="font-alMajeed text-xl md:text-2xl lg:text-3xl mt-5 lg:mt-10 md:mt-8">
          {currentAyat.ayat}{" "}
          <span className=" text-md md:text-sm lg:text-md">
            {" "}
            {currentAyat.hawala}
          </span>
        </p>
        {/* <p className="mt-3 lg:mt-7 md:mt-8 text-md md:text-sm lg:text-md">
                    {currentAyat.hawala}
                </p> */}
        <p className="mt-3 lg:mt-7 md:mt-8 text-lg md:text-xl lg:text-2xl">
          "{currentAyat.tarjuma}"
        </p>
      </div>
      <style>{`
        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: translateY(10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .fade-container {
          animation: fadeIn 1s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default AajKiBaat;
